angular.module('unica_wiki.wiki_controllers')

.controller('WikiEditController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $timeout,
	WikiEditService
) {

	$scope.pageTitle = 'Modifica Dato';

	$rootScope.getWiki( $stateParams.id );

	$scope.saveWiki = function() {
		$scope.showLoader();

		var wikiData = angular.copy($rootScope.wikiData);

		if ( typeof wikiData.image !== "undefined" ) {
			wikiData.image = wikiData.image.dataURL;
		} else {
			wikiData.image = '';
		}

		if ( wikiData.introduction_date ) {
			var introductionDate = moment(wikiData.introduction_date);
			wikiData.introduction_date = introductionDate.format('YYYY-MM-DD');
		}

		WikiEditService
			.update(wikiData)
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {

					data.image = {
						dataURL: data.image,
						resized: {
							dataURL: data.thumb
						}
					};
					data.introduction_date = moment(data.introduction_date).toDate();

					$rootScope.wikiData = data;

					$scope.showSuccessMsg('Dato aggiornato con successo!', '');
					//$state.go('app.event.list', { year: $rootScope.year });
				} else {
					$rootScope.manageError(data);
				}
			});

	};


	$scope.removeImage = function()
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			WikiEditService
				.deleteImage( $rootScope.wikiData )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$rootScope.wikiData.image = '';

						$timeout(function() {
							$rootScope.$apply();
						}, 300);

						$scope.showSuccessMsg('Immagine eliminata con successo!', '');
					}
				});

		}, function() { });
	};

})

;